import { observer } from "mobx-react";
import "./index.scss";
import ContentState from "../../../../stores/ContentState";
import H2 from "../H2";
import P18 from "../P18";
import H3 from "../H3";
import AnimatedBlock from "../AnimatedBlock";

const Values = () => {
  const { values } = ContentState.mission;
  return (
    <section className="mission-values">
      <div className="mission-values__container">
        <H2 text={values?.title} />
        <AnimatedBlock>
          <P18 text={values?.text} />
        </AnimatedBlock>
        <div className="mission-values__list">
          {values?.list?.map((c: any, i: number) => (
            <AnimatedBlock key={i}>
              <div className="mission-values__item">
                <H3 text={c?.title} />
                <P18 text={c?.text} />
              </div>
            </AnimatedBlock>
          ))}
        </div>
        <AnimatedBlock>
          <P18 text={values?.text2} />
        </AnimatedBlock>
      </div>
    </section>
  );
};

export default observer(Values);
